<template>
  <div class="home">
    <div class="navigation">
      <router-link :to="{ name: 'home' }">
          see all stickers
      </router-link>
    </div>
    <blockquote v-if="text">
      "{{ text }}"
    </blockquote>
    <div class="size">
      {{ size.width.toFixed(1) }}cm x {{ size.height.toFixed(1) }}cm
    </div>
    <div class="sticker-container">
      <StickerComponent :sticker="sticker"></StickerComponent>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import {
  Sticker,
  stickers,
  StickerData,
  stickersData,
} from '@/domain/Stickers';

import StickerComponent from '@/components/Sticker.vue';

export default defineComponent({
  name: 'StickerView',
  components: {
    StickerComponent,
  },
  data() {
    return {
      stickers,
    };
  },
  computed: {
    sticker(): Sticker | undefined {
      return stickers.find((v) => v.name === this.$route.params.name);
    },
    stickerData(): StickerData | undefined {
      return stickersData.find((v) => v.filename === `${this.$route.params.name}.webp`);
    },
    text(): string | undefined {
      if (this.sticker?.text) {
        return this.sticker?.text;
      }
      return undefined;
    },
    size(): { width: number, height: number } | undefined {
      if (this.stickerData) {
        return {
          width: this.stickerData.width,
          height: this.stickerData.height,
        };
      }
      return undefined;
    },
  },
});
</script>

<style scoped lang="scss">
.navigation {
  margin: 2em;

  a {
    color: var(--cyber-yellow);
  }
}

blockquote {
  color: var(--whitest-white);
  font-size: 30px;
  margin: 1em;
}
.sticker {
  max-width: 100%;
  min-width: 75%;
}
.size {
  color: var(--whitest-white);
  margin: 1em;
}

.sticker-container {
  width: 100%;
  height: 300px;
  overflow: hidden;

  .sticker {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
}
</style>
